// Configuração visual/funcional de uma oficina dentro da ferramenta.
//
// Quando rodando standalone, a oficina ajusta isso na tela de
// Configurações (persistido via settingsService).
//
// Quando embutida no painel administrativo, o painel pode controlar
// qualquer um destes campos passando um objeto `config` para
// <WorkshopProvider config={...}>. Um campo presente em `config` sempre
// tem prioridade sobre o que está salvo localmente — é assim que o painel
// "mãe" controla cores, logo e funções habilitadas centralmente.
export const DEFAULT_SETTINGS = {
  // AUD-B -- segmento de inspecao: "carro" (padrao) ou "moto". Uma string, e
  // nao dois booleanos, para que a exclusividade seja ESTRUTURAL: nao existe
  // estado invalido com os dois ligados. Campo de topo (nao vai em
  // `features`) porque features e mapa de booleanos; getControlledFields()
  // ja trata campos de topo e trava este contra alteracao pela oficina.
  segmento: "carro",
  logoUrl: null,
  primaryColor: "#2563eb",
  backgroundColor: "#eef2f9",
  // Padrao escuro de proposito (pedido do cliente em 18/08/2026) -- quem
  // preferir claro troca em Configuracoes, e a escolha fica salva
  // (settingsService/mergeSettings da prioridade ao que ja foi salvo).
  theme: "dark", // 'light' | 'dark'
  wallpaperKey: "solido", // ver lib/personalizacao.js (PAPEIS_FUNDO)
  features: {
    clientesVeiculos: true,
    temaEscuro: true,
    // Inspecao 3D da carroceria. Padrao DESLIGADO (AUD-A): a marcacao de
    // avaria passa a ser feita sobre a FOTO REAL do veiculo (setas, formas,
    // texto livre, cor e espessura), que nao depende de WebGL nem de tipo de
    // veiculo. O painel administrativo religa por oficina em
    // Oficinas > Editar > Checklist de Entrada, gravando em
    // oficina_config_<tenant>.checklistConfig.features.inspecao3d.
    //
    // Declarado aqui de proposito, e nao deixado implicito como `undefined`:
    // ConfigPage.jsx lista features com nomes fixos (nao varre este objeto),
    // entao declarar NAO cria toggle visivel para a oficina -- o controle
    // segue exclusivo do painel.
    inspecao3d: false,
  },
};

export function mergeSettings(stored, externalConfig) {
  const base = { ...DEFAULT_SETTINGS, ...stored };
  const ext = externalConfig || {};
  return {
    ...base,
    ...ext,
    features: {
      ...base.features,
      ...(ext.features || {}),
    },
  };
}

/** Lista os campos de nível superior controlados externamente (pelo painel admin). */
export function getControlledFields(externalConfig) {
  if (!externalConfig) return new Set();
  return new Set(Object.keys(externalConfig).filter((k) => k !== "features"));
}

export function getControlledFeatureFields(externalConfig) {
  if (!externalConfig || !externalConfig.features) return new Set();
  return new Set(Object.keys(externalConfig.features));
}
